import config from "../../config";
import {CustomerServiceError} from "./error";
import {CustomerEmailChannels, OptInState, Session} from "./customer";

export class RegisterNewsletterRequest {
  email: string;
  countryCode: string;
  birthday: Date;
  optInEmailAdvertisementConsent: boolean;
  optInEmailChannelNewsletter: boolean;
  optInEmailChannelLoyalty: boolean;
  optInEmailChannelWomensFashion: boolean;
  optInEmailChannelMensFashion: boolean;
}

export async function registerNewsletter(req: RegisterNewsletterRequest): Promise<boolean> {
  const result = await fetch(`${config.customerServiceUrl}/customer/newsletter/register`, {
    body: JSON.stringify(req),
    cache: 'no-cache',
    headers: {
      'content-type': 'application/json',
    },
    method: 'POST',
  });

  if (!result.ok) {
    const json = await result.json();
    throw new CustomerServiceError(json);
  }

  return true;
}

export async function resendVerificationMail(session: Session): Promise<boolean> {
  const result = await fetch(`${config.customerServiceUrl}/customer/${session.customerId}/resend-verification-mail`, {
    cache: 'no-cache',
    headers: {
      'content-type': 'application/json',
      'NY-SESSION-TOKEN': `${session.token}`,
    },
    method: 'POST',
  });

  if (!result.ok) {
    const json = await result.json();
    throw new CustomerServiceError(json);
  }

  return true;
}

export async function loadOptInState(session: Session): Promise<OptInState> {
  const response = await fetch(`${config.customerServiceUrl}/customer/${session.customerId}/opt-in-state`, {
    cache: 'no-cache',
    headers: {
      'content-type': 'application/json',
      'NY-SESSION-TOKEN': `${session.token}`,
    },
    method: 'GET',
  });

  if (response.ok) {
    const json = await response.json();
    return new OptInState(json);
  }
  throw new Error("[customer-service] error while loading customer email channels: " + response.statusText);
}

export async function loadCustomerEmailChannels(token: string): Promise<CustomerEmailChannels> {
  const response = await fetch(`${config.customerServiceUrl}/customer/${token}/channels`,
    {
      credentials: 'omit',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });

  if (response.ok) {
    const json = await response.json();
    return new CustomerEmailChannels(json);
  }
  throw new Error("[customer-service] error while loading customer email channels: " + response.statusText);
}

export class UpdateChannelsRequest {
  optInEmailChannelNewsletter: boolean;
  optInEmailChannelLoyalty: boolean;
  optInEmailChannelWomensFashion: boolean;
  optInEmailChannelMensFashion: boolean;
}

export async function updateCustomerEmailChannels(token: string, req: UpdateChannelsRequest): Promise<boolean> {
  const response = await fetch(`${config.customerServiceUrl}/customer/${token}/channels`,
    {
      credentials: 'omit',
      method: 'PUT',
      body: JSON.stringify(req),
      headers: {
        'Content-Type': 'application/json'
      }
    });

  if (response.ok) {
    return true
  }
  throw new Error("[customer-service] error while updating customer email channels: " + response.statusText);
}

export class EmailCampaign {
  emailId: string;
  listId: string;
}

export async function optOutAllCustomerEmailChannels(token: string, campaign: EmailCampaign): Promise<boolean> {
  const url = new URL(`${config.customerServiceUrl}/customer/${token}/opt-out`);
  if (campaign) {
    url.searchParams.append("emailId", campaign.emailId)
    url.searchParams.append("listId", campaign.listId)
  }

  const response = await fetch(url.toString(),
    {
      credentials: 'omit',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    });

  if (response.ok) {
    return true
  }
  throw new Error("[customer-service] error while updating customer email channels: " + response.statusText);
}
